// Indian GSTIN validation — structural regex + mod-36 checksum in the 15th char.
// Kept in lockstep with the backend (com.calltify.util.GstinValidator).

const STRUCTURE = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
const CODES = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const normalizeGstin = (value) => (value || '').trim().toUpperCase();

const checksumChar = (first14) => {
  const mod = CODES.length;
  let factor = 2;
  let sum = 0;
  for (let i = first14.length - 1; i >= 0; i--) {
    const code = CODES.indexOf(first14[i]);
    let addend = factor * code;
    addend = Math.floor(addend / mod) + (addend % mod);
    sum += addend;
    factor = factor === 2 ? 1 : 2;
  }
  return CODES[(mod - (sum % mod)) % mod];
};

export const isValidGstin = (value) => {
  const g = normalizeGstin(value);
  if (!STRUCTURE.test(g)) return false;
  return g[14] === checksumChar(g.slice(0, 14));
};
